<template>
  <footer class="app-footer">
    <div class="app-footer__wrapper">
      <div class="app-footer__copyright">
        &copy; {{ currentYear }} {{ COPYRIGHT }}
      </div>
      <nav class="app-footer__navigation">
        <ul>
          <li>
            <router-link :to="{ name: ROUTE_NAME.POLICY }">Policy</router-link>
          </li>
          <li>
            <router-link :to="{ name: ROUTE_NAME.TERMS }">Terms</router-link>
          </li>
        </ul>
      </nav>
    </div>
  </footer>
</template>

<script setup lang="ts">
import { ROUTE_NAME } from '@/const'

const COPYRIGHT = 'Allposit Inc. All rights reserved.'

const currentYear = new Date().getFullYear()
</script>

<style scoped>
.app-footer {
  @apply bg-gray-800;
  @apply text-white;
  @apply text-sm font-light;

  &__wrapper {
    @apply max-w-7xl sm:h-14;
    @apply flex flex-col-reverse sm:flex-row justify-between items-center;
    @apply gap-4 py-4 sm:py-0 px-4 mx-auto;
  }

  &__navigation {
    ul {
      @apply flex gap-6;
    }

    a {
      @apply underline underline-offset-2 hover:no-underline;
      @apply decoration-gray-500;
    }
  }
}
</style>
